export type Storefront = 'GIPANT' | 'HENTERPANT';

export interface StoreLinkConfig {
  appStore: string;
  googlePlay: string;
}

export const STORE_LINKS: Record<Storefront, StoreLinkConfig> = {
  GIPANT: {
    appStore: 'https://apps.apple.com/us/app/gi-pant/id6744614271',
    googlePlay: 'https://play.google.com/store/apps/details?id=gi.pant'
  },
  HENTERPANT: {
    appStore: 'https://apps.apple.com/us/app/henter-pant/id6753604465',
    googlePlay: 'https://play.google.com/store/apps/details?id=henter.pant'
  }
} as const;

